import React, { FC, ReactNode } from 'react'
import { Menu as AntMenu, Tooltip } from 'antd'
import { Link } from 'react-router-dom'
import { MenuItemProps } from 'antd/lib/menu/MenuItem'

import { Text } from '../../../common/text'

type ItemProps = {
  route: string
  icon?: ReactNode
  title: ReactNode
  extra?: ReactNode
  showTitle?: boolean
  tooltip?: ReactNode
}

const Item: FC<MenuItemProps & ItemProps> = (props) => {
  const { route, title, icon, extra, showTitle = true, tooltip, ...menuItemProps } = props

  // force assign a props to the Ant's Item to move the route value into a 'key'
  // for correct identify the selected item
  const antItemProps: MenuItemProps = { ...menuItemProps, icon: tooltip ? undefined : icon, eventKey: route }
  const link = (
    <Link to={route} className={tooltip ? 'menu-item-tooltip-link' : undefined}>
      {tooltip ? icon : null}
      {!tooltip && showTitle && <Text size={15}>{title}</Text>}
    </Link>
  )

  return (
    <AntMenu.Item {...antItemProps}>
      {tooltip ? (
        <Tooltip title={tooltip} placement={'right'} mouseEnterDelay={0.2}>
          {link}
        </Tooltip>
      ) : (
        link
      )}
      {extra}
    </AntMenu.Item>
  )
}

export default Item
